<template>
  <template v-if="isVisible">
    <template v-if="currentOrg && !primaryPaymentMethod">
      <alert
        :rounded="false"
        kind="danger"
        icon="exclamation"
        @click:cta="$router.push(getPrefixedTo('/settings/billing'))"
      >
        This organization doesn’t have a payment method.

        <template #cta>Select a payment method</template>
      </alert>
    </template>

    <template v-if="!currentOrg && !primaryPaymentMethod">
      <alert
        :rounded="false"
        kind="danger"
        icon="exclamation"
        @click:cta="$router.push('/accounts/me/settings/billing')"
      >
        You don’t have any payment methods.

        <template #cta>Add a payment method</template>
      </alert>
    </template>
  </template>
</template>
<script setup lang="ts">
  import {getPrefixedTo} from '@console/helpers/router';
  import Alert from '@/common/ui/components/Alert.vue';
  import {useStore} from 'vuex';
  import {computed, onMounted, ref} from 'vue';
  import {useRoute} from 'vue-router';

  const store = useStore();
  const state = ref('idle');
  const route = useRoute();
  const currentMember = computed(() => store.state.orgs.currentMember);

  const isVisible = computed(() => {
    if (state.value !== 'idle') {
      return false;
    }

    if (currentMember.value && !currentMember.value.canManageBilling) {
      return false;
    }

    return route.fullPath.includes('/cloud');
  });

  const primaryPaymentMethod = computed(() => {
    return store.getters['paymentMethods/primaryPaymentMethod'];
  });

  const currentOrg = computed(() => {
    return store.getters['orgs/currentOrg'];
  });

  onMounted(async () => {
    if (isVisible.value && !primaryPaymentMethod.value) {
      state.value = 'loading';
      await store.dispatch('paymentMethods/getPaymentMethods');
      state.value = 'idle';
    }
  });
</script>
